<template>
    <div class="base-estates-fields">
        <input type="hidden" v-model="results_type" name="results_type">
        <input type="hidden" v-model="id" name="id">
        <input type="hidden" v-model="city" name="city">
        <input type="hidden" v-model="contract" name="contract">
        <input type="hidden" v-model="currentDistricts" name="districts">
        <input type="hidden" v-model="currentQuarters" name="quarters">
        <input type="hidden" v-model="placeholder" name="placeholder">
        <input type="hidden" v-model="province" name="province">
        <input type="hidden" v-model="region" name="region">
        <input type="hidden" v-model="sector" name="sector">
    </div>
</template>

<script>
export default {
    props: {
        contract: {
            type: String,
            default: 'acquis',
        },
        districts: {
            type: String,
            required: false,
        },
        quarters: {
            type: String,
            required: false,
        },
        filters: {
            type: Object
        },
        geo: {
            type: String,
            required: false,
        },
        id: {
            type: [Number, String],
            required: false
        },
        results_type: {
            type: String,
            required: true
        },
        sector: {
            type: String,
            default: 'res',
        }
    },

    data() {
        return {
            filtersData: this.filters
        }
    },

    mounted() {
        window.events.$on('update_basefields', filters => {
            this.filtersData = filters.form
        })
    },

    computed: {
        city() {
            let value = null

            if(this.geo) {
                value = this.geoData.type === 'city' ? this.geoData.id : null
            }
            else if(this.filtersData != undefined) {
                value = this.filtersData.city
            }

            this.$emit('city', value)

            return value
        },

        currentDistricts() {
            let value = null

            if(this.geo) {
                value = this.geoData.type == 'districts' ? this.geoData.id : this.districts
            }
            else if(this.filtersData != undefined) {
                value = this.filtersData.districts
            }

            this.$emit('districts', value)
            return value
        },

        currentQuarters() {
            let value = null

            if(this.geo) {
                value = this.geoData.type == 'quarters' ? this.geoData.id : this.quarters
            }
            else if(this.filtersData != undefined) {
                value = this.filtersData.quarters
            }

            this.$emit('quarters', value)
            return value
        },

        geoData() {
            return JSON.parse(this.geo)
        },

        placeholder() {
            let value = null;

            if(this.geo) {
                value = this.geoData.placeholder
            }
            else if(this.filtersData != undefined) {
                value = this.filtersData.placeholder
            }

            this.$emit('placeholder', value)

            return value
        },

        province() {
            let value = null

            if(this.geo && this.geoData.type === 'province' && this.geoData.id) {
                value = this.geoData.id
            }
            else if(this.filtersData != undefined) {
                value = this.filtersData.province
            }

            this.$emit('province', value)

            return value
        },

        region() {
            let value = null

            if(this.geo && this.geoData.type === 'region' && this.geoData.id) {
                value = this.geoData.id
            }
            else if(this.filtersData != undefined) {
                value = this.filtersData.region
            }
            else if(this.geoData && this.geoData.region_id) {
                value = this.geoData.region_id
            }

            this.$emit('region', value)

            return value
        },
    },
}
</script>